/* tslint:disable */
/* eslint-disable */
/**
 * SPD
 * Opis api SPD
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetLastEditorDto
 */
export interface GetLastEditorDto {
    /**
     * 
     * @type {Date}
     * @memberof GetLastEditorDto
     */
    ts?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetLastEditorDto
     */
    owner?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetLastEditorDto
     */
    creationTs?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetLastEditorDto
     */
    creator?: string;
    /**
     * 
     * @type {Date}
     * @memberof GetLastEditorDto
     */
    additionalTs?: Date;
    /**
     * 
     * @type {string}
     * @memberof GetLastEditorDto
     */
    additionalOwner?: string;
}

/**
 * Check if a given object implements the GetLastEditorDto interface.
 */
export function instanceOfGetLastEditorDto(value: object): value is GetLastEditorDto {
    return true;
}

export function GetLastEditorDtoFromJSON(json: any): GetLastEditorDto {
    return GetLastEditorDtoFromJSONTyped(json, false);
}

export function GetLastEditorDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetLastEditorDto {
    if (json == null) {
        return json;
    }
    return {
        
        'ts': json['ts'] == null ? undefined : (new Date(json['ts'])),
        'owner': json['owner'] == null ? undefined : json['owner'],
        'creationTs': json['creationTs'] == null ? undefined : (new Date(json['creationTs'])),
        'creator': json['creator'] == null ? undefined : json['creator'],
        'additionalTs': json['additionalTs'] == null ? undefined : (new Date(json['additionalTs'])),
        'additionalOwner': json['additionalOwner'] == null ? undefined : json['additionalOwner'],
    };
}

export function GetLastEditorDtoToJSON(value?: GetLastEditorDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'ts': value['ts'] == null ? undefined : ((value['ts']).toISOString()),
        'owner': value['owner'],
        'creationTs': value['creationTs'] == null ? undefined : ((value['creationTs']).toISOString()),
        'creator': value['creator'],
        'additionalTs': value['additionalTs'] == null ? undefined : ((value['additionalTs']).toISOString()),
        'additionalOwner': value['additionalOwner'],
    };
}

